import { Image } from './common';
import { CommonRequestOptions, makeRequest } from './makeRequest';

export type Author = {
   userid: number;
   username: string;
   join_date: number;
   enabled: boolean;
   banned: boolean | null;
   image: Image;
};

export type UnsavedWikiObject = {
   dataType: 'wiki';
   display_title: string;
   image: Image;
   modified_date: number;
   summary: string;
   text: string;
   title: string;
   url: string;
   fullUrl?: string;
};

export type WikiObject = UnsavedWikiObject & {
   wikiid: number;
};

export type UnsavedWikiPage = UnsavedWikiObject & {
   namespace: 'WIKI';
};

export type WikiPage = WikiObject & UnsavedWikiPage;

export type UnsavedCategory = UnsavedWikiObject & {
   namespace: 'CATEGORY';
};

export type Category = WikiObject & UnsavedCategory;

export type UnsavedDevice = UnsavedWikiObject & {
   namespace: 'DEVICE';
};

export type Device = WikiObject & UnsavedCategory;

type GetWikisRequestOptions = CommonRequestOptions & {
   modifiedSince?: number;
   offset?: number;
   limit?: number;
   langid?: number;
};

export enum WikiNamespaces {
   WIKI = 'WIKI',
   CATEGORY = 'CATEGORY',
   ITEM = 'ITEM',
   TEAM = 'TEAM',
   COURSE = 'COURSE',
   USER = 'USER',
}

export async function getWikis({
   modifiedSince,
   offset,
   limit,
   langid,
   ...common
}: GetWikisRequestOptions): Promise<WikiPage[]> {
   return await makeRequest('get', 'wikis/WIKI', {
      ...common,
      query: {
         modifiedSince,
         offset,
         limit,
         langid,
      },
   });
}

export async function getWikiByWikiid(
   namespace: WikiNamespaces,
   wikiid: number,
   { ...common }: CommonRequestOptions
): Promise<WikiObject> {
   return await makeRequest('get', `/wikis/${namespace}/${wikiid}`, {
      ...common,
   });
}
